import {formatAmountValue} from "utils/valueFormatter.function";
import type {DocumentAmountFieldProps} from "types/documentData";
import {DocumentDataField} from "./DocumentDataField.component";

/**
 * The Amount field: the amount, and under it the converted amount with a note that it can still
 * change by the payment date, when the document is in another currency.
 */
export const DocumentAmountField = ({details, warnings, translate}: DocumentAmountFieldProps) => {
    const {amount, currency, foreignAmount, foreignCurrency} = details;
    const isConverted = !!foreignAmount && currency !== foreignCurrency;
    const formattedAmount = `${formatAmountValue(amount)} ${currency || ""}`.trim();

    if (!isConverted) {
        return <DocumentDataField id="amount" label={translate("documentData.amount")} value={formattedAmount} warnings={warnings}/>;
    }

    return (
        <DocumentDataField id="amount" label={translate("documentData.amount")} warnings={warnings}>
            <span className="document-data__amount">{formattedAmount}</span>
            <span className="document-data__converted-amount">
                {`${formatAmountValue(foreignAmount)} ${foreignCurrency || ""}`.trim()}
            </span>
            <span className="document-data__note">{translate("documentData.convertedAmountNote")}</span>
        </DocumentDataField>
    );
};
